import { useState, useEffect } from 'react';
import { currencyService } from '../services/currency';

export const useCurrency = () => {
    const [currency, setCurrency] = useState(currencyService.getCurrentCurrency());

    useEffect(() => {
        const unsubscribe = currencyService.subscribe((newCurrency) => {
            setCurrency(newCurrency);
        });

        return unsubscribe;
    }, []);

    const formatPrice = (amount: number, fromCurrency: string = 'USD') => {
        return currencyService.formatPrice(amount, fromCurrency);
    };

    const convertPrice = (amount: number, fromCurrency: string = 'USD', toCurrency?: string) => {
        return currencyService.convertPrice(amount, fromCurrency, toCurrency);
    };

    const getCurrencyInfo = (code?: string) => {
        return currencyService.getCurrencyInfo(code);
    };

    return {
        currency,
        formatPrice,
        convertPrice,
        getCurrencyInfo,
        setCurrency: (code: string) => currencyService.setCurrency(code)
    };
};

